import { FETCH_REQUEST } from '../../sharedTypes';
import { LOGIN_TENANT } from '../../fetchTypes';

export const loginRequest = data => ({
  type: FETCH_REQUEST,
  fetchType: LOGIN_TENANT,
  data,
});
